import { inject, Injectable } from "@angular/core";
import { MarkerClusterGroupOptions } from "leaflet";
import { BiMapMarker } from "../BiMapMarker";
import { BiMapTools } from "../BiMapTools";
import { BiMapService } from "../bi-map.service";

@Injectable()
export class BiMapMarkerService {
  private readonly mapService = inject(BiMapService);

  public findMarkersNotInLayer(layer: L.Polygon | L.Marker, markers: Array<BiMapMarker>, singlePinMarkerRadius: number): Array<BiMapMarker> {
    return markers.filter(marker => {
      if (this.hasBounds(layer)) return !BiMapTools.isMarkerInsidePolygon(marker, layer);

      return !this.mapService.isMarkerInsidePinMarker(layer, marker, singlePinMarkerRadius);
    });
  }

  public createMarkerClusterGroup(maxClusterRadius: number, forCriticalAddresses = false) {
    const options: MarkerClusterGroupOptions = {
      maxClusterRadius: maxClusterRadius,
      disableClusteringAtZoom: 17,
      chunkedLoading: true
    };
    if (forCriticalAddresses) {
      options.iconCreateFunction = cluster => {
        const childCount = cluster.getChildCount();

        return L.divIcon({
          className: "marker-cluster-critical",
          html: `<div><span>${childCount}</span></div>`,
          iconSize: [40, 40]
        });
      };
    }

    return L.markerClusterGroup(options);
  }

  private hasBounds(layer: L.Layer): layer is L.Layer & { getBounds(): L.LatLngBounds } {
    return (layer as L.Layer & { getBounds(): L.LatLngBounds }).getBounds !== undefined;
  }
}
